/*
 *  THIS COMPONENT IS DEPRECATED
 *  Please use <Checkbox /> from design-system instead
 */
import { Space, Spacing, Text } from '@billy/design-system'
import { css, SerializedStyles } from '@emotion/core'
import get from 'lodash/get'
import uniqueId from 'lodash/uniqueId'
import React, { ChangeEvent, ReactElement } from 'react'
import { Control, Controller } from 'react-hook-form'

import { ConnectForm, ConnectFormType } from './ConnectForm'
import { ErrorMessage } from './ErrorMessage'
import { FormControl, FormControlProps } from './FormControl'
import { InputProps } from './Input'
import * as Styled from './styles'

type CheckboxComponentProps = Omit<InputProps, 'onChange'> &
  FormControlProps & {
    css?: SerializedStyles
    defaultChecked?: boolean
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  }

const CheckboxComponent = ({
  checked,
  css: styles,
  defaultChecked,
  disconnect,
  disabled,
  id,
  label,
  name = 'checkbox-field',
  onChange = () => null,
  options = {},
  required,
  ...rest
}: CheckboxComponentProps): ReactElement => {
  const inputId = id || uniqueId('check-')

  return (
    <ConnectForm>
      {({ formState, register }: ConnectFormType) => {
        const errors = formState?.errors || {}
        const error = name ? get(errors, name) : undefined

        return (
          <FormControl
            css={[
              css`
                display: flex;
                margin-right: ${Spacing.S16};
                flex-direction: column;

                svg {
                  margin-right: 5px;
                  width: 15px;
                  height: 15px;
                }
              `,
              styles,
            ]}
            {...rest}
          >
            <Styled.CheckboxLabel htmlFor={inputId}>
              <Styled.Input
                name={name}
                type="checkbox"
                checked={checked}
                error={!!error}
                defaultChecked={defaultChecked}
                disabled={disabled}
                id={inputId}
                onChange={onChange}
                css={css`
                  margin-top: ${Spacing.S2};
                `}
                {...(!disconnect && register ? register(name, { required, ...options }) : undefined)}
              />
              {label && (
                <>
                  <Space size="s8" horizontal={true} />
                  <Text as="span" colorVariant="secondary">
                    {label}
                  </Text>
                </>
              )}
              {required && (
                <Text as="span" inherit>
                  *
                </Text>
              )}
            </Styled.CheckboxLabel>
            <ErrorMessage error={(name && errors[name]) || undefined} />
          </FormControl>
        )
      }}
    </ConnectForm>
  )
}

// Controlled
export type CheckboxControlledResult = boolean

export type CheckboxProps = CheckboxComponentProps & {
  formControl?: Control<any>
}

export const Checkbox = ({ formControl, name = '', ...rest }: CheckboxProps): ReactElement => {
  if (!formControl) {
    return <CheckboxComponent {...rest} name={name} />
  }

  return (
    <Controller
      render={({ field }) => (
        <CheckboxComponent
          {...rest}
          name={field.name}
          value={field.value}
          checked={field.value}
          onChange={(event: ChangeEvent<HTMLInputElement>) => field.onChange(event.currentTarget.checked)}
          disconnect
        />
      )}
      control={formControl}
      name={name}
    />
  )
}
